import { Injectable, Inject } from '@angular/core';
import { DwAttributeType, DwContextDefinition, DwContextRepositoryService, DwControlType, DwCustomContextBase, 
         DwCustomContextDefinition, DwExpressionCompareType, 
         DwExpressionAttribute, DwSecurityUserService, getParameterByName,
         DwOrmDataServiceToken, DwOrmDataService, DwLookupInfo, DwMetaDataServiceToken, DwMetaDataService, DwOrmData } from '@devwareapps/devware-cap';
import { RoVehicleEntity, RoAuctionEntity, CodeValueFleetAuctionStatus, AuctionEntity, FleetVehicleEntity, 
         FleetMetaDataItemNames, DepartmentMapEntity, FleetMetaDataLookups, FleetMetaData } from '../meta-data/fleet-meta-data.service';
import { map, mergeMap } from 'rxjs/operators';
import { WachterUserExt } from 'src/app/shared/models/wachter-user.model';
import { combineLatest, Observable, Subscription, of } from 'rxjs';
import { AppMetaDataService} from 'src/app/meta-data/app-meta-data.service';
import { QueryString } from '../../../shared/services/querystring.service';
import { AppPermissions } from 'src/app/meta-data/app-permissions.enum';

import * as moment_ from 'moment';
const moment = moment_;


@DwCustomContextDefinition({
    keyName: FleetAuctionContextService.ContextName,
    display: 'Fleet - Auction Details',
    isGlobal: false,
    parentItem: FleetMetaDataItemNames.Auction
})
@Injectable()
export class FleetAuctionContextService extends DwCustomContextBase {
    static ContextName: string = 'FleetAuctionContext';
    activeId: number = undefined;
    map: DepartmentMapEntity[];

    constructor(
        private queryString : QueryString,
        protected securityService: DwSecurityUserService,
        @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
        @Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService,
    ){
        super();
        this.securityService.securityContextChanged().subscribe(cxt => {
            if (this.map == undefined && this.securityService.securityState.isAuthenticated == true)
                this.getDeptMap().subscribe(list => {
                    this.map = this.map ?? list;
                });
        });
    }

    isAdminFor(map : DepartmentMapEntity, wachterUser : WachterUserExt, perm : string, grp : string){
        return  map.Group == grp && wachterUser.hasPermission(perm);
    }
    coreLogic(auc: AuctionEntity = undefined, did: number) : boolean{
        //const responsible = auc.AuctionId % 2 == 0; //<<TEMP
        if (did == undefined) return false;
        const map = this.map.find(m => m.WachterDepartmentId == did);
        const wu = new WachterUserExt(this.securityService.securityContext.ApplicationUser);
        return  this.isAdminFor(map, wu, AppPermissions.canUseFleetAdminExecSafetyView, ResponsibleGroup.Exec) ||
                this.isAdminFor(map, wu, AppPermissions.canUseFleetAdminNesView, ResponsibleGroup.Nes) ||
                this.isAdminFor(map, wu, AppPermissions.canUseFleetAdminNspLbuView, ResponsibleGroup.NspLbu) ||
                this.isAdminFor(map, wu, AppPermissions.canUseFleetAdminRolloutView, ResponsibleGroup.RollOut) ||
                this.isAdminFor(map, wu, AppPermissions.canUseFleetAdminWecIndustrialView, ResponsibleGroup.WecInd);
    }
    
    isResponsible(finalPrice: number = undefined, auc: AuctionEntity = undefined, did: number = undefined) : any {
        const isActive = this.isActive(auc);
        const addBid = this.queryString.exists('AddBid');
        return  {   Responsible : auc == undefined ? !addBid : this.coreLogic(auc,did), 
                    FinalPrice: finalPrice, Active: isActive };
    }
    isActive(auc: AuctionEntity) : boolean{
        if (auc == undefined) 
            return false;
        /* Basing on automatically enabled status vs timestamps which can vary from client to server */
        return auc?.StatusCv == CodeValueFleetAuctionStatus.ActiveOpen;
        // const currentTime = moment().local();
        // const startTime = moment.utc(auc.StartDateTime).local();
        // const endTime = moment.utc(auc.EndDateTime).local();
        // return startTime.isValid() && endTime.isValid() && currentTime > startTime && currentTime < endTime;
    }

    setupContextDefinition(contextDef: DwContextDefinition) {
        contextDef.getCustomContextFunction = (resolvedContext => {
            const auc: AuctionEntity = resolvedContext?.data;
            const vid : number = auc?.VehicleId;
            const aid : number = auc?.AuctionId;

            if (resolvedContext?.respOnly == true)
                return this.isResponsible(undefined, auc, resolvedContext?.data?.RoVehicleWachterDepartmentId);
            else if (auc == undefined || vid == undefined) 
                return this.isResponsible();
            else{
                const roVehOb = this.getRoVehicle(vid);
                const roAucOb = this.getRoAuc(aid);
                const deptMapOb = this.map == undefined ? this.getDeptMap() : of(this.map);
                
                return combineLatest([roVehOb, roAucOb, deptMapOb])
                        .pipe(mergeMap(([roVeh, roAuc, deptMap]) => {
                            this.map = this.map ?? deptMap;
                            
                            if (resolvedContext.formApi != undefined && roAuc.FinalBid != null && auc.FinalPrice == undefined)
                                resolvedContext.formApi.patchFormData({ FinalPrice: roAuc.FinalBid});
                            const v : RoVehicleEntity = roVeh;
                            const did = v?.WachterDepartmentId;
                            return of(did == undefined
                                    ? this.isResponsible()
                                    : this.isResponsible(roAuc.FinalBid, auc, did));
                        }));
            }
        });
        contextDef.attributes = [];
        const attrs = contextDef.attributes;
        var attrDN : DwExpressionAttribute = this.addProperty(  attrs, 'Responsible', 'Is User Responsible Fleet Admin', 
                                                                        DwAttributeType.YesNo, DwControlType.YesNoDropDown);
        var attrActive : DwExpressionAttribute = this.addProperty(  attrs, 'Active', 'Is Active', 
                                                                    DwAttributeType.YesNo, DwControlType.YesNoDropDown);
        var attrFP : DwExpressionAttribute = this.addProperty(  attrs, 'FinalPrice', 'Final Price', 
                                                                DwAttributeType.Text, DwControlType.Textbox);
        var attrOS : DwExpressionAttribute = this.addProperty(  attrs, 'OrigStatus', 'Original Status', 
                                                                DwAttributeType.Integer, DwControlType.DropDownList);
        attrOS.compareTypes = [ DwExpressionCompareType.contains, DwExpressionCompareType.notContains, 
                                DwExpressionCompareType.inList, DwExpressionCompareType.notInList,
                                DwExpressionCompareType.equal, DwExpressionCompareType.notEqual];
        attrOS.Attribute.IsLookup = true;
        attrOS.Attribute.MetaDataLookupId = FleetMetaDataLookups.CodeValueFleetAuctionStatus;
    }

    getDeptMap() : Observable<DwOrmData[]> {
        const md = new  AppMetaDataService();
        const query = md.DepartmentMap.CreateQuery();
        let data = this.dataService.executeQuery(query);
        return data;
    }
    getRoAuc(aucId : number) : Observable<RoAuctionEntity> {
        return this.dataService.loadEntity(FleetMetaDataItemNames.RoAuction, aucId);
    }
    obsVeh : Observable<RoVehicleEntity>;
    getRoVehicle(vid: number) : Observable<RoVehicleEntity>{
        this.obsVeh = this.obsVeh ?? this.loadRoVehicle(vid);
        return this.obsVeh;
    }
    loadRoVehicle(vid: number) : Observable<RoVehicleEntity>{
        return this.dataService.loadEntity(FleetMetaDataItemNames.RoVehicle, vid)
    }
}
export enum ResponsibleGroup { RollOut = 'ROLLOUT', NspLbu = 'NSP/LBU', WecInd = 'WEC/IND', Nes = 'NES', Exec = 'EXEC' }